export const NO_RESOURCE = "no-resource";

export const SPARRAD_TID = "sparrad-tid-";

export const CALENDAR_VIEWS = {
    day: {
        type: "timeGridDay",
    },
    week: {
        type: "timeGridWeek",
    },
    opsalTimeline: {
        type: "resourceTimelineDay",
    },
    opsalDay: {
        type: "resourceTimeGridDay",
    },
    avdelningDayTimeline: {
        type: "resourceTimelineDay",
        duration: {
            days: 2,
        },
    },
};
